import { UserDtoSchema } from "@/modules/profile/userProfile/userDto"
import { BoxSlotParticipationSchema } from "@modules/boxSlot/boxSlotTypes"
import { z } from "zod"

export const BoxSlotItemDtoSchema = z
  .object({
    id: z.string(),
    startTime: z.iso.datetime(),
    endTime: z.iso.datetime(),
    programId: z.string(),
    programName: z.string(),
    color: z.string(),
    registeredParticipantCount: z.number(),
    pendingParticipantCount: z.number(),
    participantLimit: z.number(),
    sessionId: z.string().nullable(),
    location: z.string().nullable(),
    isFromTemplate: z.boolean(),
    participation: BoxSlotParticipationSchema.nullable(),
    allowMultiBooking: z.boolean(),
    dropinsAccepted: z.boolean(),
    trialsAccepted: z.boolean(),
    assignedStaffMembers: z.array(z.lazy(() => UserDtoSchema)),
  })
  .meta({ id: "BoxSlotItemDtoSchema" })

export type BoxSlotItemDto = z.infer<typeof BoxSlotItemDtoSchema>

export const BoxSlotDetailsDtoSchema = BoxSlotItemDtoSchema.extend({
  contentEarlyAccess: z.boolean(),
}).meta({ id: "BoxSlotDetailsDtoSchema" })
export type BoxSlotDetailsDto = z.infer<typeof BoxSlotDetailsDtoSchema>

export const BoxSlotCreateOrUpdateInputDtoSchema = z
  .object({
    programId: z.string(),
    startTime: z.iso.datetime(),
    endTime: z.iso.datetime(),
    sessionId: z.string().nullable(),
    participantLimit: z.number().nullable(),
    contentEarlyAccess: z.boolean().nullable(),
    location: z.string().nullable(),
    participation: BoxSlotParticipationSchema.nullable(),
    allowMultiBooking: z.boolean(),
    assignedStaffMembers: z.array(z.string()).nullable(),
    dropinsAccepted: z.boolean(),
    trialsAccepted: z.boolean(),
  })
  .meta({ id: "BoxSlotCreateOrUpdateInputDtoSchema" })

export type BoxSlotCreateOrUpdateInputDto = z.infer<typeof BoxSlotCreateOrUpdateInputDtoSchema>
